module.exports = __webpack_public_path__ + "media/images/icons/country_flags/fj-4487fd6fe344bff5f5949a001eab9155.svg";